/**
 * Created by JackCui on 2022/9/19
 */

import {FIELD_TYPE, PROJECT_CODE} from '../../constants'
import {HEADER_PARAMS_KEYS} from '../../constants'
import response from '../../../utils/response'
import api from './api'

// 接口类型1-列表接口 4-查字段值接口
const sceneMap = {
  1: 'getList',
  4: 'getValue'
}

// 分页接口请求参数
const paginationParams = {
  pageSize: 200,
  page: 1
}

// 需要请求能力接口的字段
const abilityFields = [FIELD_TYPE.LOOKUP_RELATION, FIELD_TYPE.QUOTE]

// 初始化接口信息
export function interfacesHandle (interfaces, row, defaultParams) {
  const {url, requestType, responseParams, requestParams, supportPage} = interfaces
  const {searchKey} = requestParams
  const params = {}

  for (let k in requestParams) {
    const paramKey = requestParams[k]
    if (row[paramKey]) {
      params[paramKey] = row[paramKey]
    }
  }

  return {
    interfaces: {
      url,
      type: requestType
    },
    params: Object.assign(
      params,
      supportPage ? paginationParams : {}
    ),
    responseParams
  }
}

// 重新拼装schema 主对象 从对象, 加入本对象能力数据
export async function processAbility (schema, subSchema = []) {
  const process = async (schema) => {
    const {info, fields} = schema.data
    const hasAbility = fields.find(v => abilityFields.includes(v.type))
    // _objectApiName: 处理聚合页面的objectApiName
    const {objectApiName, _objectApiName, apiName} = info

    // 布局内没有引用或者查找关联字段 则不请求能力获取接口避免无用请求
    schema.data.ability = hasAbility
      ? await getAbility({
        objectApiName: _objectApiName || objectApiName,
        layoutApiName: apiName
      })
      : {}
    return schema
  }
  return Promise.all([process(schema), ...subSchema.map(v => process(v))])
}

// 批量获取能力
export async function getAbility ({objectApiName, layoutApiName}) {
  const map = {}
  const url = `${api.getAbility.url}/${objectApiName}/${layoutApiName}`
  const {isOk, content} = await response({
    method: api.getAbility.type,
    url,
    headerParams: {
      [HEADER_PARAMS_KEYS.tenantType]: PROJECT_CODE
    }
  })

  if (isOk) {
    content.forEach(v => {
      const interfaces = {}
      v.interfaces.forEach(k => {
        interfaces[sceneMap[k.scene]] = k
      })
      map[v.fieldSeqCode] = {
        ...v,
        interfaces
      }
    })
  }

  return map
}
